export class SuccessModel {
  constructor() {
    this.isSuccess = false;
    this.result = undefined;
    this.id = undefined;
  }

  isSuccess?: boolean;
  result?: any;
  id?: number;
  problemId?: number;
  problemTrackingId?: number;
}
